// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-group {\n  margin: 0;\n}\n.searchContainer{\n    float: right;\n    margin-top: -50px;\n    max-width: 300px;\n    margin-bottom: 10px;\n}\n\n", ""]);
// Exports
module.exports = exports;
